import { Card, CardHeader, CardTitle, CardContent } from '@repo/ui';
import { useMemo } from 'react';

interface DexVolume {
  date: string;
  dex_name: string;
  volume_usd: number;
  trade_count: number;
}

interface DexTableProps {
  data: DexVolume[];
}

export function DexTable({ data }: DexTableProps) {
  // 오늘 데이터로 집계
  const latestDate = useMemo(() => {
    const dates = Array.from(new Set(data.map(d => d.date))).sort().reverse();
    return dates[0];
  }, [data]);
  
  const todayData = useMemo(() => {
    return data
      .filter(d => d.date === latestDate)
      .sort((a, b) => b.volume_usd - a.volume_usd);
  }, [data, latestDate]);
  
  const totalVolume = todayData.reduce((sum, d) => sum + d.volume_usd, 0);
  
  return (
    <Card>
      <CardHeader>
        <CardTitle>DEX Rankings (24h)</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-200">
                <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">#</th>
                <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">DEX</th>
                <th className="text-right py-3 px-4 text-sm font-semibold text-gray-700">Volume (24h)</th>
                <th className="text-right py-3 px-4 text-sm font-semibold text-gray-700">Trades</th>
                <th className="text-right py-3 px-4 text-sm font-semibold text-gray-700">Market Share</th>
              </tr>
            </thead>
            <tbody>
              {todayData.map((dex, idx) => (
                <tr key={dex.dex_name} className="border-b border-gray-100 hover:bg-gray-50">
                  <td className="py-3 px-4 text-sm text-gray-600">{idx + 1}</td>
                  <td className="py-3 px-4 text-sm font-medium text-gray-900">{dex.dex_name}</td>
                  <td className="py-3 px-4 text-sm text-right text-gray-900">
                    ${dex.volume_usd.toLocaleString()}
                  </td>
                  <td className="py-3 px-4 text-sm text-right text-gray-600">
                    {dex.trade_count.toLocaleString()}
                  </td>
                  <td className="py-3 px-4 text-sm text-right text-gray-600">
                    {((dex.volume_usd / totalVolume) * 100).toFixed(1)}%
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
